// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1XLNg","header":"Messages_header__-ZUQf"};